export const fashion_beauty = [
  { char: '💄', name: 'Lipstick', nameZh: '彩妝口紅', keywords: ['makeup', 'beauty', 'sephora', '化妝'], hot: true },
  { char: '👗', name: 'Dress', nameZh: '氣質洋裝', keywords: ['ootd', 'fashion', 'style', '衣服'] },
  { char: '👜', name: 'Handbag', nameZh: '精品包包', keywords: ['luxury', 'bag', 'fashion'] },
  { char: '👠', name: 'High-Heeled Shoe', nameZh: '高跟鞋', keywords: ['fashion', 'party', 'shoes'] },
  { char: '💅', name: 'Nail Polish', nameZh: '美甲', keywords: ['beauty', 'nails', 'relax'], hot: true },
  { char: '💍', name: 'Ring', nameZh: '戒指配件', keywords: ['jewelry', 'gift', 'marry'] },
  { char: '🕶️', name: 'Sunglasses', nameZh: '質感墨鏡', keywords: ['cool', 'summer', 'style'] },
  { char: '🧴', name: 'Lotion', nameZh: '保養護膚', keywords: ['skincare', 'beauty', 'spa'], hot: true },
  { char: '🎨', name: 'Palette', nameZh: '眼影盤', keywords: ['makeup', 'art', 'color'] },
  { char: '💇‍♀️', name: 'Woman Cutting Hair', nameZh: '髮型設計', keywords: ['hair', 'salon', 'style'] },
  { char: '🪮', name: 'Hair Pick', nameZh: '髮梳', keywords: ['hair', 'style', '梳子'], year: 2024 },
  { char: '👒', name: 'Hat', nameZh: '遮陽帽', keywords: ['fashion', 'summer', 'vacation'] },
];